<app-modal-header
  [title]="title"
  (closeModal)="closeModal()"
></app-modal-header>

<mat-tab-group
  [(selectedIndex)]="selectedTab"
  (selectedIndexChange)="onTabChange($event)"
>
  <mat-tab label="High Humidity"></mat-tab>
  <mat-tab label="Low Humidity"></mat-tab>
  <mat-tab label="High Temperature"></mat-tab>
  <mat-tab label="Low Temperature"></mat-tab>
</mat-tab-group>

<div class="mt-4">
  <app-paginated-data-table
    [tableConfigurations]="tableConfiguration"
    [permissions]="permissions"
    (customAction)="onCustomAction($event)"
    [query]="query"
    [additionalVariables]="filters"
    [actionButtons]="actionButtons"
    [mapFunction]="mapFunction"
  >
  </app-paginated-data-table>
</div>
